import React, { lazy, Suspense } from 'react';

const LazyDailyReport = lazy(() => import('./DailyReport'));

const DailyReport = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazyDailyReport {...props} />
  </Suspense>
);

export default DailyReport;
